export default __webpack_public_path__ + "assets/84f8db6a0594b76290e6da6546dc33c5.png";